import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BarcodeScannerService {
  private buffer = '';
  private barcodeSubject = new Subject<string>();

  barcode$ = this.barcodeSubject.asObservable();

  private static readonly IGNORED_KEYS = new Set([
    'Shift',
    'CapsLock',
    'NumLock',
    'ScrollLock',
    'Tab',
    'Escape',
    'Dead',
    'Control',
    'Alt',
    'Meta',
    'ArrowUp',
    'ArrowDown',
    'ArrowLeft',
    'ArrowRight',
    'Home',
    'End',
    'PageUp',
    'PageDown',
    'Insert',
    'Delete',
    'F1',
    'F2',
    'F3',
    'F4',
    'F5',
    'F6',
    'F7',
    'F8',
    'F9',
    'F10',
    'F11',
    'F12',
  ]);

  private static readonly CODE_TO_CHAR: Record<string, string> = {
    Minus: '-',
  };

  constructor() {
    this.listenForScannerInput();
  }

  private sanitizeBarcode(raw: string): string {
    let barcode = raw.trim();

    if (barcode.includes('#')) {
      barcode = barcode.split('#').pop() || '';
    }

    return barcode;
  }

  private listenForScannerInput() {
    window.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        if (this.buffer.length > 0) {
          const barcode = this.sanitizeBarcode(this.buffer);
          this.buffer = '';
          if (barcode.length > 0) {
            this.barcodeSubject.next(barcode);
          }
        }
      } else if (!event.ctrlKey && !event.altKey && !event.metaKey && !BarcodeScannerService.IGNORED_KEYS.has(event.key)) {
        const char = BarcodeScannerService.CODE_TO_CHAR[event.code] ?? event.key;
        if (char.length === 1) {
          this.buffer += char;
        }
      }
    });
  }
}
